module.exports = __webpack_public_path__ + "img/money.421688de.svg";